import { render, staticRenderFns } from "./WallManagementComponent.vue?vue&type=template&id=63c750eb"
import script from "./WallManagementComponent.vue?vue&type=script&lang=ts"
export * from "./WallManagementComponent.vue?vue&type=script&lang=ts"
import style0 from "./WallManagementComponent.vue?vue&type=style&index=0&id=63c750eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports